export { NewCustomerTabs } from './new-customer-tabs'
